import { api, authHeader } from "../configs/axiosConfigs";

const baseUrl = "/SLN/Management/Reports";

const LeadConsultationFollowUpPerformanceReportApi = {
  getFilterData: async () => {
    const response = await api.request({
      url: `${baseUrl}/GetLeadConsultationFollowUpPerformanceFilterData`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getReport: async (searchParams) => {
    const response = await api.request({
      url: `${baseUrl}/LeadConsultationFollowUpPerformance`,
      method: "POST",
      headers: authHeader(),
      data: searchParams,
    });
    return response.data;
  },
};

export default LeadConsultationFollowUpPerformanceReportApi;
